"use client";

import { BanknoteIcon, GiftIcon, NfcIcon } from "lucide-react";

import { Marquee } from "@/components/ui/Marquee";

// Ways clients can pay at the POS. Card logos come from /public/card-brands.
const PAYMENT_METHODS = [
    { key: "visa", label: "Visa", logo: "/card-brands/visa.svg" },
    { key: "apple-pay", label: "Apple Pay", text: "Apple Pay" },
    { key: "amex", label: "American Express", logo: "/card-brands/amex.svg" },
    { key: "mastercard", label: "Mastercard", logo: "/card-brands/mastercard.svg" },
    { key: "google-pay", label: "Google Pay", text: "Google Pay" },
    { key: "discover", label: "Discover", logo: "/card-brands/discover.svg" },
    { key: "tap", label: "Tap to pay", text: "Tap to pay", Icon: NfcIcon },
    { key: "cash", label: "Cash", text: "Cash", Icon: BanknoteIcon },
    { key: "gift-card", label: "Gift card", text: "Gift card", Icon: GiftIcon },
];

function PaymentMethodTile({ method }) {
    const { label, logo, text, Icon } = method;
    return (
        <div
            title={label}
            style={{ width: 136, height: 68 }}
            className="flex shrink-0 items-center justify-center gap-2 rounded-2xl border border-neutral-200 bg-white shadow-[0_6px_20px_rgba(10,27,33,0.06)] px-4 text-neutral-900"
        >
            {logo ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img src={logo} alt={label} style={{ height: 34 }} className="w-auto" />
            ) : (
                <>
                    {Icon && <Icon className="size-5 shrink-0" />}
                    <span className="whitespace-nowrap text-base font-semibold">{text}</span>
                </>
            )}
        </div>
    );
}

// "Checkout on screen" strip for the POS feature page, shown under the hero
// image: heading, short text and a scrolling row of the payment methods the
// POS accepts.
export function FeaturePaymentMethodsSection() {
    return (
        <section className="mt-20 md:mt-24">
            <div className="grid items-center gap-6 md:grid-cols-2 md:gap-12">
                <h2 className="text-3xl font-semibold leading-tight text-neutral-900 md:text-[2.25rem]">
                    On-screen checkout, any way they pay
                </h2>
                <p className="text-base leading-relaxed text-neutral-600 md:text-lg">
                    Ring up services, products and tips on a tablet, then take cards, tap to pay,
                    digital wallets, cash or gift cards in the same checkout.
                </p>
            </div>

            <div
                className="mt-12"
                style={{
                    maskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
                    WebkitMaskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
                }}
            >
                <Marquee pauseOnHover repeat={2} duration="60s" gap="2.5rem">
                    {PAYMENT_METHODS.map((method) => (
                        <PaymentMethodTile key={method.key} method={method} />
                    ))}
                </Marquee>
            </div>
        </section>
    );
}
